import styled from 'styled-components'

export const Content = styled.span`
  ${({ font }) => font && `font-family: ${font};`}
  ${({ color }) => color && `color: ${color};`}
`
